import React from 'react';
import { getUriFromDocument } from "@utils/routing"
import { linkProps } from "@utils/general"
import { Link } from "gatsby"
import { uid } from 'react-uid';
import { getBgColorFromHex, getTextColorFromHex } from '@utils/general';

const getLabelClassname = (labelText) => {
  if (labelText === "Bestseller") return "py-1.5 px-2.5 z-[1] text-xs font-medium leading-3 rounded-md w-fit inline-flex items-center gap-1 bg-green-primary text-white";
  if (labelText === "Compare") return "py-1.5 px-2.5 z-[1] text-xs font-medium leading-3 rounded-md w-fit inline-flex items-center gap-1 bg-white text-slate";
  if (
    labelText?.toLowerCase().includes("off") ||
    labelText?.toLowerCase().includes("bundle") ||
    labelText === "Sale" ||
    labelText === "Limited Time"
  ) return "py-1.5 px-2.5 z-[1] text-xs font-medium leading-3 rounded-md w-fit inline-flex items-center gap-1 bg-red text-white";
  return "py-1.5 px-2.5 z-[1] text-xs font-medium leading-3 rounded-md w-fit inline-flex items-center gap-1 bg-white text-slate";
};

const ImageLabels = ({ labels }) => {
  const labelList = labels?.labelList?.map(label => {
    if (label.isProductReference) {
      const { title, slug, productGroups, isBundle, _type, _id } = label.productReference;
      const { color, variantColor, shopifyId } = label.variantReference;
      const productUrl = getUriFromDocument({ slug, productGroups, _type }) + (!isBundle ? '?variantId=' + shopifyId : '')

      return (
        <Link
          to={productUrl}
          title={`${title} in ${color}`}
          className={getLabelClassname(label.label)}
          key={_id}
        >
          {title} in
          <span className="rounded-xl inline-block w-3 h-3 relative" style={{ backgroundColor: variantColor && variantColor[0]?.color?.hex }}></span>
          {color}
        </Link>
      )
    } else if (label.internalLink || label.externalLink) {
      return (
        <Link {...linkProps(label.internalLink, label.externalLink)} className={getLabelClassname(label.label)} key={uid} >
          {label.label}
        </Link>
      )
    } else {
      return <p className={getLabelClassname(label.label)}>{label.label}</p>
    }
  })

  return <>
    {labels?._type !== 'flagLabel' ? (
      <div className={`absolute p-2.5 lg:p-10 md:p-10 flex gap-5 box-border ${labels?.imageLabelPosition || 'left-0 bottom-0'}`}>
        {labelList}
      </div>
    ) : (
      <div className="absolute p-2.5 md:p-5 flex gap-5 box-border top-0 left-0">
        {labels.settings?.colorSettings?.bgColor ? (
          <span
            style={{
              backgroundColor: labels.settings.colorSettings.bgColor,
              color: labels.settings.colorSettings.textColor || '#FFFFFF'
            }}
            className="py-1.5 px-2.5 z-[1] text-xs font-medium leading-3 rounded-md inline-flex items-center"
          >
            {labels.label}
          </span>
        ) : (
          <p className={getLabelClassname(labels.label)}>{labels.label}</p>
        )}
      </div>
    )}
  </>
}

export default ImageLabels;